export default class Route {
    constructor( titles, tagLines, contents, intros, categories, files, images, pois, options, featuredImage, model3d, publishDate) {
        // Object MultiLanguage
        this.titles = titles;
        this.tagLines = tagLines;
        this.contents = contents;
        this.intros = intros;
        // Arrays
        this.categories = categories;
        this.files = files;
        this.images = images;
        this.pois = pois;
        this.options = options;
        // Object
        this.featuredImage = featuredImage;
        this.model3d = model3d;
        // String
        this.publishDate = publishDate;
    }

    isValid() {
        var result = true;

        for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.tagLines)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.contents)) { if(!value) { result = false; break; }; }
        for (const [key, value] of Object.entries(this.intros)) { if(!value) { result = false; break; }; }
        
        if(result) result = this.categories && this.categories.length && this.pois && this.pois.length && this.options && this.options.length && this.featuredImage && this.model3d;
        
        return result;
    }
}